interface DiagnosisData {
  step1: Record<number, [number, number, number, number, number, number]>
  step2: Record<number, [number, number, number, number, number, number]>
  step3: Record<number, [number, number, number, number, number, number]>
  step4: Record<number, [number, number, number, number, number, number]>
  step5: Record<number, [number, number, number, number, number, number]>
  step6: Record<number, [number, number, number, number, number, number]>
}

export const diagnosisData: DiagnosisData = {
  step1: {
    1: [0, 2, 0, 0, 0, 2],
    2: [2, 1, 1, 1, 1, 1],
    3: [2, 1, 1, 2, 1, 0],
    4: [0, 1, 1, 2, 2, 0]
  },
  step2: {
    1: [2, 2, 1, 0, 0, 1],
    2: [2, 0, 1, 2, 1, 0],
    3: [1, 0, 0, 1, 2, 0],
    4: [1, 1, 0, 1, 2, 0]
  },
  step3: {
    1: [2, 2, 0, 0, 1, 0],
    2: [2, 1, 0, 0, 1, 0],
    3: [1, 1, 1, 1, 1, 0],
    4: [0, 0, 1, 1, 0, 1],
    5: [0, 0, 2, 1, 0, 2]
  },
  step4: {
    1: [2, 2, 0, 0, 1, 0],
    2: [2, 2, 0, 0, 1, 0],
    3: [1, 1, 1, 2, 0, 0],
    4: [0, 0, 2, 2, 0, 1],
    5: [0, 0, 1, 1, 0, 2]
  },
  step5: {
    1: [2, 1, 0, 0, 2, 0],
    2: [0, 0, 2, 2, 0, 1],
    3: [2, 2, 1, 0, 1, 0],
    4: [2, 0, 1, 2, 0, 0],
    5: [2, 0, 0, 0, 0, 0]
  },
  step6: {
    1: [2, 2, 0, 0, 1, 0],
    2: [2, 1, 0, 0, 1, 0],
    3: [1, 1, 1, 1, 0, 0],
    4: [0, 0, 2, 2, 0, 2]
  }
} 
